<template>
	<b-container>
		<b-progress
			:max="100"
			:value="progress"
			variant="custom"
		/>
		<h3 class="loading-text mt-3">
			Loading your saved quote...
		</h3>
	</b-container>
</template>

<script>
import BProgress from 'bootstrap-vue/es/components/progress/progress';

export default {
	name: 'QuoteContinue',
	components: {
		BProgress,
	},
	data() {
		return {
			leadToken: '',
			loadingTime: 3,
			progress: 0,
		};
	},
	computed: {
		loadingIncrement: function() {
			return 100 / ((this.loadingTime * 1000) / 90);
		},
	},
	watch: {
		async leadToken() {
			try {
				let progressTimer = window.setInterval(() => {
					if (this.progress <= 100) {
						this.progress += this.loadingIncrement;
					} else {
						window.clearInterval(progressTimer);
						progressTimer = null;
					}
				}, 90);

				await this.$store.dispatch('quote/getExistingLeadData', {
					leadToken: this.leadToken,
				});

				this.getLeadStatus()
					.then(status => {
						const checkProgress = setInterval(() => {
							this.$log.info(this.leadToken, status);

							if (progressTimer) {
								return false;
							}

							window.clearInterval(checkProgress);

							if (['hold', 'stream'].includes(status)) {
								this.$router.replace({ name: 'Quote-Phone' });
							} else {
								window.location.replace(
									`https://my.topmoving.com/thank-you/${
										this.leadToken
									}`
								);
							}
						}, 60);
					})
					.catch(err => {
						this.$log.error(err);
						this.$router.replace({ name: 'Pickup' });
					});
			} catch (err) {
				this.$router.replace({ name: 'Pickup' });
			}
		},
	},
	created() {
		this.leadToken = this.$route.query['lead-token'];

		if (!this.leadToken) {
			this.$router.replace({ name: 'Pickup' });
		}
	},
	methods: {
		async getLeadStatus() {
			try {
				const resp = await this.$ireloApi.get(
					`/lead/status/${this.leadToken}`
				);

				this.$log.info(resp.data);

				return resp.data.state;
			} catch (err) {
				throw new Error(err);
			}
		},
	},
};
</script>

<style scoped lang="scss">
.loading-text {
	color: #9f9f9f;
	font-size: 1.25rem;
	font-weight: 600;
	line-height: 1.2;
	margin-top: 1rem;
}
</style>
